/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useRef } from "react";
import { Link } from "react-router-dom";
import "./Web192059.css";

function Web192059(props) {
  const {
    butterflyNebula,
    whatResembleButter,
    wingright,
    leftwing,
    overlapGroup2,
    viewFullscreenImage,
    polygon3,
    video,
    backToImage
  } = props;

  const btnRef = useRef();
  const animationRef = useRef();

  useEffect(() => {
    if (btnRef && btnRef.current) {
      const button = btnRef.current
      button.addEventListener('click', function () {
        if (animationRef && animationRef.current && button && btnRef.current) {
          if (animationRef.current.classList.contains("animate-up")) {
            animationRef.current.classList.remove("animate-up")
            animationRef.current.classList.add("animate-down")
          } else {
            animationRef.current.classList.remove("animate-down")
            animationRef.current.classList.add("animate-up")
          }
        }

      });
    }
  }, [animationRef])

  return (
    <div className="container-center-horizontal video">
      <div className="web-1920-59 screen">

        <video loop={true} autoPlay muted={false} playsInline webkit-playsinline={1}>
          <source src={video} type="video/mp4" />
        </video>
        <div className="wrap_elliptic deep_sonification animate-up" ref={animationRef}>
          <div className="overlap-group2-6 hand-cursor" ref={btnRef} style={{ backgroundImage: `url(${overlapGroup2})` }}>
            <div className="view-fullscreen-image-7 lato-medium-white-14px">{viewFullscreenImage}</div>
            <img className="polygon-3-7 popup-animate" src={polygon3} />
          </div>
          <div className="left_content">
            <img src={leftwing} className="wing_left" />
            <img src={wingright} className="wing_right" />
            <div className="the-antennae-galaxies lato-bold-white-30px">{butterflyNebula}</div>

            <div className="the-antennae-galaxie lato-medium-white-26px">{whatResembleButter}</div>

            <Link to="/web-1920-147/0">
              <div className="group-142-9">
                <div className="overlap-group-31">
                  <div className="rectangle-33-14 border-3px-picton-blue">
                    <div className="back-to-image-6 lato-medium-white-13px">{backToImage}</div>
                  </div>
                </div>
              </div>
            </Link>
          </div>
        </div>

      </div>
    </div>
  );
}

export default Web192059;
